import React from 'react';
import './styles.css';

const RadioGroup = ({
  children,
  value,
  onChange,
  name,
  className = '',
  row = false,
  ...props
}) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
  };
  console.log(value, 'value');
  return (
    <div
      className={`custom-radio-group ${
        row ? 'radio-group-row' : 'radio-group-column'
      } ${className}`}
      {...props}>
      {React.Children.map(children, (child) => {
        console.log(child.props, 'child');
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            name: name,
            checked: child.props.value === value,
            onChange: handleChange,
          });
        }
        return child;
      })}
    </div>
  );
};

export default RadioGroup;
